import React, { useEffect, useState } from 'react';
import Button from '../base/Button';
import './MobileStickyCTA.css';

function MobileStickyCTA() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const signupSection = document.getElementById('signup');
    
    if (!signupSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Hide when signup section is visible
        setIsVisible(!entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(signupSection);

    return () => observer.disconnect();
  }, []);

  const scrollToSignup = () => {
    const element = document.getElementById('signup');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="mobile-sticky-cta">
      <Button 
        onClick={scrollToSignup}
        variant="primary"
        showArrow={true}
        className="mobile-sticky-cta-button"
      >
        Start with us
      </Button>
    </div>
  );
}

export default MobileStickyCTA;



